module.exports = __webpack_public_path__ + "img/icon_del.2a7f4f7d.svg";